import React from 'react'
import { Link } from '@shopify/hydrogen'
import classNames from 'classnames'
import classes from './BlockInfo.module.scss'
import { InfoBlock } from '~/types/block-types'
import ImageVideo from '~/components/common/image-video/image-video.client'
import RichTextRenderer from '~/components/common/rich-text/rich-text.client'

export interface BlockInfoProps extends InfoBlock {
  // For now we don't have any other props that we need to define but this might be subject to change
  // as the design changes in the future.
  // imgLeft?: boolean
  // imgBottomOnPhone?: boolean
}

const BlockInfo: React.FC<BlockInfoProps> = ({
  subtitle,
  title,
  imagewidth,
  imageOnBottom,
  description,
  content,
  imageOnLeft,
  link,
}) => {

  const blockStyles = classNames(
    classes.BlockInfo,
    imageOnBottom && classes.ImgBottom,
    !imageOnLeft && classes.ImageRight,
  )

  const isVideo = content?._type !== 'imageWithLink' && content?._type !== 'videoUrl'

  const isVideoUrl = content?._type !== 'videoAnimation' && content?._type !== 'imageWithLink'
  const ctaLink = link?._type === 'linkExternal' ? link.url : link?.slug
  const ctaText = link?.title
  const externalTarget = link?._type === 'linkExternal' && link.newWindow

  const ctaHider = classNames(
    !ctaText && !ctaLink && classes.ctaHiderBtn,
    ctaText && ctaLink && classes.ReadMoreBtn
  )
  return (
    <div className={blockStyles}
      style={{
        gridTemplateColumns: !imageOnLeft ? `auto ${imagewidth}%` : `${imagewidth}% auto` 
      }}>
      {content &&
        <div className={classes.ImageContainer}>
          <ImageVideo content={content} isVideo={isVideo} imageOnLeft={imageOnLeft} isVideoUrl={isVideoUrl} />
        </div>}

      <div className={classes.Content}>
        <h5>{subtitle}</h5>
        <h2>{title}</h2>
        {description &&
          <div className={classes.Quote}>
            <RichTextRenderer content={description} />
          </div>
        }
        {ctaText && ctaLink && (
          <Link
            to={ctaLink}
            className={classes.ReadMoreBtn}
            target={externalTarget ?  '_blank' : '_self'}
          >
            <span>{ctaText}</span>
          </Link>)}
      </div>
    </div>
  )
}

export default BlockInfo


